import axios from "axios";

export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api/v1"
    : "https://axaobe-1.onrender.com/api/v1";
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

const postApi = async (url, option, config = {}) => {
  try {
    const res = (await axiosInstance.post(url, option, config)).data;
    if (res.success) {
      return { data: res, error: null };
    }
    return { data: null, error: res };
  } catch (error) {
    return {
      data: null,
      error: error.response
        ? { ...error.response.data, status: error.response.status }
        : { message: error.message, networkError: true },
    };
  }
};

const fetchApi = async (url) => {
  try {
    const res = (await axiosInstance.get(url)).data;
    if (res.success || res.sucess) {
      return { data: res, error: null };
    }
    return { data: null, error: res };
  } catch (error) {
    return {
      data: null,
      error: error.response ? error.response.data : error.message,
    };
  }
};

export { postApi, fetchApi };
